export const isMongoId = (value: string) => {
  const objectIdRegex = /^[0-9a-fA-F]{24}$/;
  return typeof value === 'string' && objectIdRegex.test(value);
};
